'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _rcTable = require('rc-table');

var _rcTable2 = _interopRequireDefault(_rcTable);

var _checkbox = require('../checkbox');

var _checkbox2 = _interopRequireDefault(_checkbox);

var _radio = require('../radio');

var _radio2 = _interopRequireDefault(_radio);

var _filterDropdown = require('./filterDropdown');

var _filterDropdown2 = _interopRequireDefault(_filterDropdown);

var _pagination = require('../pagination');

var _pagination2 = _interopRequireDefault(_pagination);

var _icon = require('../icon');

var _icon2 = _interopRequireDefault(_icon);

var _objectAssign2 = require('object-assign');

var _objectAssign3 = _interopRequireDefault(_objectAssign2);

var _spin = require('../spin');

var _spin2 = _interopRequireDefault(_spin);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _util = require('./util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function noop() {}

var defaultLocale = {
  filterTitle: '筛选',
  filterConfirm: '确定',
  filterReset: '重置',
  emptyText: '暂无数据'
};

var defaultPagination = {
  pageSize: 10,
  current: 1,
  onChange: noop,
  onShowSizeChange: noop
};

var AntTable = _react2["default"].createClass({
  displayName: 'AntTable',
  getInitialState: function getInitialState() {
    return {
      // 减少状态
      selectedRowKeys: this.props.selectedRowKeys || [],
      filters: {},
      selectionDirty: false,
      sortColumn: '',
      sortOrder: '',
      sorter: null,
      radioIndex: null,
      pagination: this.hasPagination() ? (0, _objectAssign3["default"])({
        size: this.props.size
      }, defaultPagination, this.props.pagination) : {}
    };
  },
  getDefaultProps: function getDefaultProps() {
    return {
      dataSource: [],
      prefixCls: 'ant-table',
      useFixedHeader: false,
      rowSelection: null,
      className: '',
      size: 'large',
      loading: false,
      bordered: false,
      indentSize: 20,
      onChange: noop,
      locale: {}
    };
  },


  propTypes: {
    dataSource: _react2["default"].PropTypes.array,
    prefixCls: _react2["default"].PropTypes.string,
    useFixedHeader: _react2["default"].PropTypes.bool,
    rowSelection: _react2["default"].PropTypes.object,
    className: _react2["default"].PropTypes.string,
    size: _react2["default"].PropTypes.string,
    loading: _react2["default"].PropTypes.bool,
    bordered: _react2["default"].PropTypes.bool,
    onChange: _react2["default"].PropTypes.func,
    locale: _react2["default"].PropTypes.object
  },

  getDefaultSelection: function getDefaultSelection() {
    var _this = this;

    if (!this.props.rowSelection || !this.props.rowSelection.getCheckboxProps) {
      return [];
    }
    return this.getFlatCurrentPageData().filter(function (item) {
      return _this.props.rowSelection.getCheckboxProps(item).defaultChecked;
    }).map(function (record, rowIndex) {
      return _this.getRecordKey(record, rowIndex);
    });
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if ('pagination' in nextProps && nextProps.pagination !== false) {
      this.setState({
        pagination: (0, _objectAssign3["default"])({}, defaultPagination, this.state.pagination, nextProps.pagination)
      });
    }
    // dataSource 的变化会清空选中项
    if ('dataSource' in nextProps && nextProps.dataSource !== this.props.dataSource) {
      this.setState({
        selectionDirty: false
      });
    }
    if (nextProps.rowSelection && 'selectedRowKeys' in nextProps.rowSelection) {
      this.setState({
        selectedRowKeys: nextProps.rowSelection.selectedRowKeys || []
      });
    }
  },
  setSelectedRowKeys: function setSelectedRowKeys(selectedRowKeys) {
    var _this2 = this;

    if (this.props.rowSelection && !('selectedRowKeys' in this.props.rowSelection)) {
      this.setState({ selectedRowKeys: selectedRowKeys });
    }
    if (this.props.rowSelection && this.props.rowSelection.onChange) {
      var data = this.getFlatCurrentPageData();
      var selectedRows = data.filter(function (row, i) {
        return selectedRowKeys.indexOf(_this2.getRecordKey(row, i)) >= 0;
      });
      this.props.rowSelection.onChange(selectedRowKeys, selectedRows);
    }
  },
  hasPagination: function hasPagination() {
    return this.props.pagination !== false;
  },
  toggleSortOrder: function toggleSortOrder(order, column) {
    var _props;

    var sortColumn = this.state.sortColumn;
    var sortOrder = this.state.sortOrder;
    var sorter = void 0;
    // 只同时允许一列进行排序，否则会导致排序顺序的逻辑问题
    var isSortColumn = this.isSortColumn(column);
    if (!isSortColumn) {
      // 当前列未排序
      sortOrder = order;
      sortColumn = column;
    } else {
      // 当前列已排序
      if (sortOrder === order) {
        // 切换为未排序状态
        sortOrder = '';
        sortColumn = null;
      } else {
        // 切换为排序状态
        sortOrder = order;
      }
    }
    if (typeof column.sorter === 'function') {
      sorter = function sorter(a, b) {
        var result = column.sorter(a, b);
        if (result !== 0) {
          return sortOrder === 'descend' ? -result : result;
        }
        return a.index - b.index;
      };
    }
    var newState = {
      sortOrder: sortOrder,
      sortColumn: sortColumn,
      sorter: sorter
    };
    this.setState(newState);
    (_props = this.props).onChange.apply(_props, _toConsumableArray(this.prepareParamsArguments(_extends({}, this.state, newState))));
  },
  handleFilter: function handleFilter(column, nextFilters) {
    var _this3 = this,
        _props2;

    var filters = (0, _objectAssign3["default"])({}, this.state.filters, _defineProperty({}, this.getColumnKey(column), nextFilters));
    // Remove filters not in current columns
    var currentColumnKeys = this.props.columns.map(function (c) {
      return _this3.getColumnKey(c);
    });
    Object.keys(filters).forEach(function (columnKey) {
      if (currentColumnKeys.indexOf(columnKey) < 0) {
        delete filters[columnKey];
      }
    });
    var newState = {
      selectionDirty: false,
      filters: filters
    };
    this.setState(newState);
    this.setSelectedRowKeys([]);
    (_props2 = this.props).onChange.apply(_props2, _toConsumableArray(this.prepareParamsArguments(_extends({}, this.state, newState))));
  },
  handleSelect: function handleSelect(record, rowIndex, e) {
    var _this4 = this;

    var checked = e.target.checked;
    var defaultSelection = this.state.selectionDirty ? [] : this.getDefaultSelection();
    var selectedRowKeys = this.state.selectedRowKeys.concat(defaultSelection);
    var key = this.getRecordKey(record, rowIndex);
    if (checked) {
      selectedRowKeys.push(this.getRecordKey(record, rowIndex));
    } else {
      selectedRowKeys = selectedRowKeys.filter(function (i) {
        return key !== i;
      });
    }
    this.setState({
      selectionDirty: true
    });
    this.setSelectedRowKeys(selectedRowKeys);
    if (this.props.rowSelection.onSelect) {
      var data = this.getFlatCurrentPageData();
      var selectedRows = data.filter(function (row, i) {
        return selectedRowKeys.indexOf(_this4.getRecordKey(row, i)) >= 0;
      });
      this.props.rowSelection.onSelect(record, checked, selectedRows);
    }
  },
  handleRadioSelect: function handleRadioSelect(record, rowIndex, e) {
    var _this5 = this;

    var checked = e.target.checked;
    var defaultSelection = this.state.selectionDirty ? [] : this.getDefaultSelection();
    var selectedRowKeys = this.state.selectedRowKeys.concat(defaultSelection);
    var key = this.getRecordKey(record, rowIndex);
    selectedRowKeys = [key];
    this.setState({
      radioIndex: key,
      selectionDirty: true
    });
    this.setSelectedRowKeys(selectedRowKeys);
    if (this.props.rowSelection.onSelect) {
      var data = this.getFlatCurrentPageData();
      var selectedRows = data.filter(function (row, i) {
        return selectedRowKeys.indexOf(_this5.getRecordKey(row, i)) >= 0;
      });
      this.props.rowSelection.onSelect(record, checked, selectedRows);
    }
  },
  handleSelectAllRow: function handleSelectAllRow(e) {
    var _this6 = this;

    var checked = e.target.checked;
    var data = this.getFlatCurrentPageData();
    var defaultSelection = this.state.selectionDirty ? [] : this.getDefaultSelection();
    var selectedRowKeys = this.state.selectedRowKeys.concat(defaultSelection);
    var changableRowKeys = data.filter(function (item) {
      return !_this6.props.rowSelection.getCheckboxProps || !_this6.props.rowSelection.getCheckboxProps(item).disabled;
    }).map(function (item, i) {
      return _this6.getRecordKey(item, i);
    });

    // 记录变化的列
    var changeRowKeys = [];
    if (checked) {
      changableRowKeys.forEach(function (key) {
        if (selectedRowKeys.indexOf(key) < 0) {
          selectedRowKeys.push(key);
          changeRowKeys.push(key);
        }
      });
    } else {
      changableRowKeys.forEach(function (key) {
        if (selectedRowKeys.indexOf(key) >= 0) {
          selectedRowKeys.splice(selectedRowKeys.indexOf(key), 1);
          changeRowKeys.push(key);
        }
      });
    }
    this.setState({
      selectionDirty: true
    });
    this.setSelectedRowKeys(selectedRowKeys);
    if (this.props.rowSelection.onSelectAll) {
      var selectedRows = data.filter(function (row, i) {
        return selectedRowKeys.indexOf(_this6.getRecordKey(row, i)) >= 0;
      });
      var changeRows = data.filter(function (row, i) {
        return changeRowKeys.indexOf(_this6.getRecordKey(row, i)) >= 0;
      });
      this.props.rowSelection.onSelectAll(checked, selectedRows, changeRows);
    }
  },
  handlePageChange: function handlePageChange(current) {
    var _props3;

    var pagination = (0, _objectAssign3["default"])({}, this.state.pagination);
    if (current) {
      pagination.current = current;
    } else {
      pagination.current = pagination.current || 1;
    }
    pagination.onChange(pagination.current);

    var newState = {
      selectionDirty: false,
      pagination: pagination
    };
    this.setState(newState);
    (_props3 = this.props).onChange.apply(_props3, _toConsumableArray(this.prepareParamsArguments(_extends({}, this.state, newState))));
  },
  onRadioChange: function onRadioChange(ev) {
    this.setState({
      radioIndex: ev.target.value
    });
  },
  renderSelectionRadio: function renderSelectionRadio(value, record, index) {
    var rowIndex = this.getRecordKey(record, index); // 从 1 开始
    var props = {};
    if (this.props.rowSelection.getCheckboxProps) {
      props = this.props.rowSelection.getCheckboxProps.call(this, record);
    }
    var checked = void 0;
    if (this.state.selectionDirty) {
      checked = this.state.radioIndex === rowIndex;
    } else {
      checked = this.state.radioIndex === rowIndex || this.getDefaultSelection().indexOf(rowIndex) >= 0;
    }
    return _react2["default"].createElement(_radio2["default"], { disabled: props.disabled,
      onChange: this.handleRadioSelect.bind(this, record, rowIndex),
      value: rowIndex, checked: checked });
  },
  renderSelectionCheckBox: function renderSelectionCheckBox(value, record, index) {
    var rowIndex = this.getRecordKey(record, index); // 从 1 开始
    var checked = void 0;
    if (this.state.selectionDirty) {
      checked = this.state.selectedRowKeys.indexOf(rowIndex) >= 0;
    } else {
      checked = this.state.selectedRowKeys.indexOf(rowIndex) >= 0 || this.getDefaultSelection().indexOf(rowIndex) >= 0;
    }
    var props = {};
    if (this.props.rowSelection.getCheckboxProps) {
      props = this.props.rowSelection.getCheckboxProps.call(this, record);
    }
    return _react2["default"].createElement(_checkbox2["default"], { checked: checked, disabled: props.disabled,
      onChange: this.handleSelect.bind(this, record, rowIndex) });
  },
  getRecordKey: function getRecordKey(record, index) {
    if (this.props.rowKey) {
      return this.props.rowKey(record, index);
    }
    return record.key || index;
  },
  renderRowSelection: function renderRowSelection() {
    var _this7 = this;

    var columns = this.props.columns.concat();
    if (this.props.rowSelection) {
      var data = this.getFlatCurrentPageData().filter(function (item) {
        if (_this7.props.rowSelection.getCheckboxProps) {
          return !_this7.props.rowSelection.getCheckboxProps(item).disabled;
        }
        return true;
      });
      var checked = void 0;
      if (!data.length) {
        checked = false;
      } else {
        checked = this.state.selectionDirty ? data.every(function (item, i) {
          return _this7.state.selectedRowKeys.indexOf(_this7.getRecordKey(item, i)) >= 0;
        }) : data.every(function (item, i) {
          return _this7.state.selectedRowKeys.indexOf(_this7.getRecordKey(item, i)) >= 0;
        }) || data.every(function (item) {
          return _this7.props.rowSelection.getCheckboxProps && _this7.props.rowSelection.getCheckboxProps(item).defaultChecked;
        });
      }
      var selectionColumn = void 0;
      if (this.props.rowSelection.type === 'radio') {
        selectionColumn = {
          key: 'selection-column',
          render: this.renderSelectionRadio,
          className: 'ant-table-selection-column'
        };
      } else {
        var checkboxAllDisabled = data.every(function (item) {
          return _this7.props.rowSelection.getCheckboxProps && _this7.props.rowSelection.getCheckboxProps(item).disabled;
        });
        var checkboxAll = _react2["default"].createElement(_checkbox2["default"], { checked: checked,
          disabled: checkboxAllDisabled,
          onChange: this.handleSelectAllRow });
        selectionColumn = {
          key: 'selection-column',
          title: checkboxAll,
          render: this.renderSelectionCheckBox,
          className: 'ant-table-selection-column'
        };
      }
      if (columns[0] && columns[0].key === 'selection-column') {
        columns[0] = selectionColumn;
      } else {
        columns.unshift(selectionColumn);
      }
    }
    return columns;
  },
  getColumnKey: function getColumnKey(column, index) {
    return column.key || column.dataIndex || index;
  },
  isSortColumn: function isSortColumn(column) {
    if (!column || !this.state.sortColumn) {
      return false;
    }
    var colKey = this.getColumnKey(column);
    var isSortColumn = this.getColumnKey(this.state.sortColumn) === colKey;
    return isSortColumn;
  },
  renderColumnsDropdown: function renderColumnsDropdown(columns) {
    var _this8 = this;

    var locale = (0, _objectAssign3["default"])({}, defaultLocale, this.props.locale);
    return columns.map(function (originColumn, i) {
      var column = (0, _objectAssign3["default"])({}, originColumn);
      var key = _this8.getColumnKey(column, i);
      var filterDropdown = void 0;
      var sortButton = void 0;
      if (column.filters && column.filters.length > 0) {
        var colFilters = _this8.state.filters[key] || [];
        filterDropdown = _react2["default"].createElement(_filterDropdown2["default"], { locale: locale, column: column,
          selectedKeys: colFilters,
          confirmFilter: _this8.handleFilter });
      }
      if (column.sorter) {
        var isSortColumn = _this8.isSortColumn(column);
        if (isSortColumn) {
          column.className = column.className || '';
          if (_this8.state.sortOrder) {
            column.className += ' ant-table-column-sort';
          }
        }

        var isAscend = isSortColumn && _this8.state.sortOrder === 'ascend';
        var isDescend = isSortColumn && _this8.state.sortOrder === 'descend';
        sortButton = _react2["default"].createElement(
          'div',
          { className: 'ant-table-column-sorter' },
          _react2["default"].createElement(
            'span',
            { className: 'ant-table-column-sorter-up ' + (isAscend ? 'on' : 'off'),
              title: '↑',
              onClick: _this8.toggleSortOrder.bind(_this8, 'ascend', column) },
            _react2["default"].createElement(_icon2["default"], { type: 'caret-up' })
          ),
          _react2["default"].createElement(
            'span',
            { className: 'ant-table-column-sorter-down ' + (isDescend ? 'on' : 'off'),
              title: '↓',
              onClick: _this8.toggleSortOrder.bind(_this8, 'descend', column) },
            _react2["default"].createElement(_icon2["default"], { type: 'caret-down' })
          )
        );
      }
      column.title = _react2["default"].createElement(
        'span',
        null,
        column.title,
        sortButton,
        filterDropdown
      );
      return column;
    });
  },
  handleShowSizeChange: function handleShowSizeChange(current, pageSize) {
    var _props4;

    var pagination = this.state.pagination;
    pagination.onShowSizeChange(current, pageSize);
    var nextPagination = _extends({}, pagination, { pageSize: pageSize, current: current });
    this.setState({ pagination: nextPagination });
    (_props4 = this.props).onChange.apply(_props4, _toConsumableArray(this.prepareParamsArguments(_extends({}, this.state, {
      pagination: nextPagination
    }))));
  },
  renderPagination: function renderPagination() {
    // 强制不需要分页
    if (!this.hasPagination()) {
      return null;
    }
    var classString = (0, _classnames2["default"])({
      'ant-table-pagination': true,
      mini: this.props.size === 'middle' || this.props.size === 'small'
    });
    var total = this.state.pagination.total || this.getLocalData().length;
    var pageSize = this.state.pagination.pageSize;
    return total > 0 ? _react2["default"].createElement(_pagination2["default"], _extends({}, this.state.pagination, {
      className: classString,
      onChange: this.handlePageChange,
      total: total,
      pageSize: pageSize,
      onShowSizeChange: this.handleShowSizeChange })) : null;
  },
  prepareParamsArguments: function prepareParamsArguments(state) {
    // 准备筛选、排序、分页的参数
    var pagination = state.pagination;
    var filters = state.filters;
    var sorter = {};
    if (state.sortColumn && state.sortOrder && state.sortColumn.dataIndex) {
      sorter.field = state.sortColumn.dataIndex;
      sorter.order = state.sortOrder;
    }
    return [pagination, filters, sorter];
  },
  findColumn: function findColumn(myKey) {
    var _this9 = this;

    return this.props.columns.filter(function (c) {
      return _this9.getColumnKey(c) === myKey;
    })[0];
  },
  getCurrentPageData: function getCurrentPageData() {
    var data = this.getLocalData();
    var current = void 0;
    var pageSize = void 0;
    var state = this.state;
    // 如果没有分页的话，默认全部展示
    if (!this.hasPagination()) {
      pageSize = Number.MAX_VALUE;
      current = 1;
    } else {
      pageSize = state.pagination.pageSize;
      current = state.pagination.current;
    }
    // 分页
    // ---
    // 当数据量少于等于每页数量时，直接设置数据
    // 否则进行读取分页数据
    if (data.length > pageSize || pageSize === Number.MAX_VALUE) {
      data = data.filter(function (item, i) {
        return i >= (current - 1) * pageSize && i < current * pageSize;
      });
    }
    return data;
  },
  getFlatCurrentPageData: function getFlatCurrentPageData() {
    return (0, _util.flatArray)(this.getCurrentPageData());
  },
  getLocalData: function getLocalData() {
    var _this10 = this;

    var state = this.state;
    var data = this.props.dataSource || [];
    // 排序
    if (state.sortOrder && state.sorter) {
      data = data.slice(0);
      for (var i = 0; i < data.length; i++) {
        data[i].index = i;
      }
      data = data.sort(state.sorter);
    }
    // 筛选
    if (state.filters) {
      Object.keys(state.filters).forEach(function (columnKey) {
        var col = _this10.findColumn(columnKey);
        if (!col) {
          return;
        }
        var values = state.filters[columnKey] || [];
        if (values.length === 0) {
          return;
        }
        data = col.onFilter ? data.filter(function (record) {
          return values.some(function (v) {
            return col.onFilter(v, record);
          });
        }) : data;
      });
    }
    return data;
  },
  render: function render() {
    var _classNames;

    var data = this.getCurrentPageData();
    var columns = this.renderRowSelection();
    var expandIconAsCell = this.props.expandedRowRender && this.props.expandIconAsCell !== false;
    var locale = (0, _objectAssign3["default"])({}, defaultLocale, this.props.locale);

    var classString = (0, _classnames2["default"])((_classNames = {}, _defineProperty(_classNames, 'ant-table-' + this.props.size, true), _defineProperty(_classNames, 'ant-table-bordered', this.props.bordered), _defineProperty(_classNames, this.props.className, !!this.props.className), _classNames));

    columns = this.renderColumnsDropdown(columns);
    columns = columns.map(function (column, i) {
      var newColumn = (0, _objectAssign3["default"])({}, column);
      newColumn.key = newColumn.key || newColumn.dataIndex || i;
      return newColumn;
    });
    var emptyText = void 0;
    var emptyClass = '';
    if (!data || data.length === 0) {
      emptyText = _react2["default"].createElement(
        'div',
        { className: 'ant-table-placeholder' },
        _react2["default"].createElement(_icon2["default"], { type: 'frown' }),
        locale.emptyText
      );
      emptyClass = ' ant-table-empty';
    }

    var table = _react2["default"].createElement(
      'div',
      null,
      _react2["default"].createElement(_rcTable2["default"], _extends({}, this.props, {
        data: data,
        columns: columns,
        className: classString,
        expandIconColumnIndex: columns[0] && columns[0].key === 'selection-column' ? 1 : 0,
        expandIconAsCell: expandIconAsCell })),
      emptyText
    );
    if (this.props.loading) {
      // if there is no pagination or no data,
      // the height of spin should decrease by half of pagination
      var paginationPatchClass = this.hasPagination() && data && data.length !== 0 ? 'ant-table-with-pagination' : 'ant-table-without-pagination';
      var spinClassName = paginationPatchClass + ' ant-table-spin-holder';
      table = _react2["default"].createElement(
        _spin2["default"],
        { className: spinClassName },
        table
      );
    }
    return _react2["default"].createElement(
      'div',
      { className: 'clearfix' + emptyClass },
      table,
      this.renderPagination()
    );
  }
});

exports["default"] = AntTable;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./components/basic/table/index.jsx
 ** module id = 423
 ** module chunks = 0
 **/